const DISPLAY_NAME = { api: 'API', github: 'GitHub', gitlab: 'GitLab' };
const EDIT_TEXT = { github: 'Edit on GitHub', gitlab: 'Edit on GitLab' };

export const externalDisplayName = (platform) =>
  DISPLAY_NAME[platform] || 'External';
export const externalEditText = (platform) =>
  EDIT_TEXT[platform] || 'Edit source';
